export default "__VITE_ASSET__XYY7V6Fn__"